import classNames from "classnames";
import styles from "./Loader.module.scss";

function Loader({
  ref,
  className,
  color = "primary",
  size = "medium",
  withOverlay,
}: {
  ref?: React.Ref<HTMLDivElement>;
  className?: string;
  color?: "primary" | "white" | "gray";
  size?: "xsmall" | "small" | "medium";
  withOverlay?: boolean;
}) {
  if (withOverlay) {
    return (
      <div ref={ref} className={classNames(styles.overlay, className)}>
        <div className={classNames(styles.loader, styles[color], styles[size])}>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    );
  }

  return (
    <div
      ref={ref}
      className={classNames(
        styles.loader,
        styles[color],
        styles[size],
        className,
      )}
    >
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}

export default Loader;
